import { Article, AIGenerationResponse, AIStoryGenerationResponse, AIImageGenerationResponse } from '../types';
import axiosConnector from './axiosConnector';
import { toArticleDTO } from '../dto/articleDTO';
import { API_URL } from './axiosConnector';

interface AIResponse {
  title: string;
  body: string;
  tokens: number;
  price: number;
  remaining_completions: number;
}

interface AIImageResponse {
  fileUrl: string;
  price: number;
  remaining_completions: number;
}

interface AIStoryResponse {
  title: string;
  tokens: number;
  price: number;
  remaining_completions: number;
}

interface ErrorResponse {
  error: string;
}

// https://openai.com/api/pricing/ gpt-4o
const MODEL_INPUT_TOKEN_PRICE = 2.5 / 1000000;
const MODEL_OUTPUT_TOKEN_PRICE = 10 / 1000000;

export const generateArticle = async (
  prompt: string
): Promise<AIResponse | ErrorResponse | undefined> => {
  try {
    const aiResponse = await axiosConnector.post<AIGenerationResponse>(
      `${API_URL}/articles/generate`,
      {
        prompt,
      }
    );

    const price: number =
      aiResponse.data.tokens.prompt_tokens * MODEL_INPUT_TOKEN_PRICE +
      aiResponse.data.tokens.completion_tokens * MODEL_OUTPUT_TOKEN_PRICE;

    const response: AIResponse = {
      title: aiResponse.data.article.title,
      body: aiResponse.data.article.body,
      tokens: aiResponse.data.tokens.total_tokens,
      price,
      remaining_completions: aiResponse.data.remaining_completions,
    };

    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const generateStory = async (
  prompt: string
): Promise<AIStoryResponse | ErrorResponse | undefined> => {
  try {
    const aiResponse = await axiosConnector.post<AIStoryGenerationResponse>(
      `${API_URL}/stories/generate`,
      {
        prompt,
      }
    );

    const price: number =
      aiResponse.data.tokens.prompt_tokens * MODEL_INPUT_TOKEN_PRICE +
      aiResponse.data.tokens.completion_tokens * MODEL_OUTPUT_TOKEN_PRICE;

    const response: AIStoryResponse = {
      title: aiResponse.data.story.title,
      tokens: aiResponse.data.tokens.total_tokens,
      price,
      remaining_completions: aiResponse.data.remaining_completions,
    };

    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const generateImage = async (
  prompt: string
): Promise<AIImageResponse | ErrorResponse | undefined> => {
  try {
    const aiResponse = await axiosConnector.post<AIImageGenerationResponse>(
      `${API_URL}/stories/generate-image`,
      {
        prompt,
      }
    );

    const price: number = 0.05;

    const response: AIImageResponse = {
      fileUrl: aiResponse.data.fileUrl,
      price,
      remaining_completions: aiResponse.data.remaining_completions,
    };

    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
};